import { config, productId } from '../Constants';
import { get, post } from './service';
import { getData as getLocalData } from './local-service';
import { buildQueryString } from './helper';

const APIURL_GET_DATA = config.url.API_URL + '/Assessment/GetAssessment';
const APIURL_UPDATE_DATA = config.url.API_URL + '/Assessment/UpdateParticipant';
const APIURL_SAVE_DATA = config.url.API_URL + '/Assessment/Save';
const APIURL_LOG = config.url.API_URL + '/Assessment/Logger';

const getDataFunc = (params, successFunc, errorFunc, finallFunc) => {
	if (!params || !params.versionId) {
		params.versionId = -1;
	}

	const queryString = buildQueryString({
		productId,
		filterByTask: false,
		...params
	});

	get(APIURL_GET_DATA + queryString, null, successFunc, errorFunc, finallFunc);
};

export const getData = config.isLocal ? getLocalData : getDataFunc;
export const updateData = (params, successFunc, errorFunc, finallFunc) => post(APIURL_UPDATE_DATA, params, successFunc, errorFunc, finallFunc, true);
export const saveData = (params, successFunc, errorFunc, finallFunc) => post(APIURL_SAVE_DATA, params, successFunc, errorFunc, finallFunc, true);
export const log = (params, successFunc, errorFunc, finallFunc) => post(APIURL_LOG, params, successFunc, errorFunc, finallFunc, true);